import { format } from 'owa-strings';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import getAccountInformationService from '../../services/getAccountInformationService';
import strings from 'owa-strings/owa-mail-strings';
var SHOW_NOTIFICATION_PERCENTAGE = 95;
var SHOW_ALERT_PERCENTAGE = 98;
/**
 * show notification on mailbox quota warning
 */
export default function showNotificationOnMailBoxQuotaWarning() {
    getAccountInformationService().then(function (jsonResponse) {
        var totalMbxSize;
        var currentMbxUsed = jsonResponse.AccountInfo.Statistics.TotalItemSize.Value;
        if (jsonResponse.AccountInfo.Mailbox.UseDatabaseQuotaDefaults) {
            totalMbxSize = jsonResponse.AccountInfo.Statistics.DatabaseProhibitSendReceiveQuota;
        }
        else {
            totalMbxSize = jsonResponse.AccountInfo.Mailbox.ProhibitSendReceiveQuota;
        }
        var percentFull = (currentMbxUsed / totalMbxSize.Value) * 100;
        if (percentFull < SHOW_NOTIFICATION_PERCENTAGE || totalMbxSize.IsUnlimited) {
            return;
        }
        var notificationText = format(strings.mailboxQuotaPercentFull, percentFull.toFixed(2));
        notificationText +=
            percentFull >= SHOW_ALERT_PERCENTAGE
                ? strings.mailboxQuotaBlockSend
                : strings.mailboxQuotaWarning;
        lazyShowNotification.importAndExecute('mailboxQuotaWarningNotification', notificationText, {
            primaryActionText: 'View Storage',
            allowAutoDismiss: false,
            shouldShowDismissIcon: true,
            notificationCallback: function (reason) {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    lazyMountAndShowFullOptions.importAndExecute('general', 'storage');
                }
            },
        });
    });
}
//# sourceMappingURL=showNotificationOnMailboxQuotaWarning.js.map